import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { MLFields, toML } from "./_ui";

export default function FooterEditor({ footer, onChange }) {
  const f = footer || {};
  const set = (k, v) => onChange({ ...f, [k]: v });

  return (
    <div className="border border-neutral-200 rounded-lg bg-white p-5 space-y-5 max-w-2xl">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="font-semibold text-sm">Футер / Контакты</h3>
          <p className="text-xs text-neutral-500 mt-0.5">Пустые поля не отображаются на сайте.</p>
        </div>
        <div className="flex items-center gap-2">
          <span className="text-xs text-neutral-500">{f.show_footer !== false ? "показан" : "скрыт"}</span>
          <Switch checked={f.show_footer !== false} onCheckedChange={(v) => set("show_footer", v)} data-testid="footer-show-toggle" />
        </div>
      </div>

      <div className={`space-y-4 ${f.show_footer !== false ? "" : "opacity-50 pointer-events-none"}`}>
        <div className="space-y-1.5">
          <Label>Email (ссылка mailto:)</Label>
          <Input type="email" value={f.email || ""} onChange={(e) => set("email", e.target.value)} className="border-neutral-300" placeholder="info@carinspecto.com" data-testid="footer-email-input" />
        </div>
        <div className="space-y-1.5">
          <Label>Телефон (ссылка tel:)</Label>
          <Input value={f.phone || ""} onChange={(e) => set("phone", e.target.value)} className="border-neutral-300" placeholder="+7 900 000-00-00" data-testid="footer-phone-input" />
        </div>
        <div className="space-y-1.5">
          <Label>Физический адрес — на 4 языках</Label>
          <MLFields value={toML(f.address)} onChange={(v) => set("address", v)} testid="footer-address" />
        </div>
        <div className="space-y-1.5">
          <Label>Свободный текст (о компании) — на 4 языках</Label>
          <MLFields value={toML(f.company_note)} onChange={(v) => set("company_note", v)} testid="footer-note" />
        </div>
      </div>
    </div>
  );
}
